module.exports = __webpack_public_path__ + "static/2-5475fa83229c1163a967a4c8bb12678d.png";